import { NgModule, inject, provideAppInitializer } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from "@angular/common/http";
import { ServiceWorkerModule } from "@angular/service-worker";

import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgbActiveModal, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgHttpLoaderComponent, pendingRequestsInterceptor$ } from "ng-http-loader";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { OAuthModule } from "angular-oauth2-oidc";

import { ClientConfigurationImpl, NgMcsAppModule } from "ng-mcs-app";
import { FormsModule as MCSForms, SubmitInterceptor } from "@motorcitysystems/core";
import { NgAdminApiModule } from "ng-admin-api";
import { NgGaugeApiModule } from "ng-gauge-api";
import { NgIdentityApiModule } from "ng-identity-api";
import { FeaturePipe, NgIdentityUIModule } from "ng-identity-ui";
import { NgMcsAppInsightsModule } from "ng-mcs-appinsights";
import { NgMcsCommonUIModule } from "ng-mcs-common-ui";
import { NgMcsDesktopModule } from "ng-mcs-desktop";
import { NgMcsE2EModule } from "ng-mcs-e2e";

import { AppComponent } from "./app.component";
import { AppIconsModule } from "./app-icons.module";
import { AppRoutingModule } from "./app-routing.module";
import { AppStoreModule } from "./app-store.module";
import { environment } from "../environments/environment";
import { GridStateManagerService, gridStateInitializerFactory } from "./core/services";
import { NgGeolocationApiModule } from "ng-geolocation-api";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppIconsModule,
    AppRoutingModule,
    AppStoreModule,
    BrowserModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    FormsModule,
    NgbModule,
    NgHttpLoaderComponent,
    NgGaugeApiModule.forRoot(environment.gaugeBaseUrl, ClientConfigurationImpl),
    NgGeolocationApiModule.forRoot(environment.geolocationBaseApiUrl, ClientConfigurationImpl),
    NgIdentityApiModule.forRoot(environment.identityBaseUrl, ClientConfigurationImpl),
    NgAdminApiModule.forRoot(environment.adminBaseUrl, ClientConfigurationImpl),
    NgIdentityUIModule,
    NgMcsAppInsightsModule.forRoot(environment.applicationInsights),
    NgMcsAppModule.forRoot({
      auth: environment.auth,
      version: environment.production ? environment.version : null,
    }),
    NgMcsCommonUIModule.forRoot(),
    NgMcsDesktopModule.forRoot({
      apiUrl: environment.identityBaseUrl,
      appId: "identity",
      env: environment.name,
      name: "IDENTITY",
      tagline: "Identity Management",
      identityAppUrl: environment.identityAppUrl,
    }),
    NgMcsE2EModule.forRoot({
      readyDebounceTime: 300,
    }),
    NgxMaskDirective,
    OAuthModule.forRoot(),
    ReactiveFormsModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      registrationStrategy: "registerImmediately",
      enabled: environment.production,
    }),
    MCSForms,
    NgxTrimDirectiveModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    FeaturePipe,
    NgbActiveModal,
    provideNgxMask(),
    provideAppInitializer(() => {
      const initializerFn = gridStateInitializerFactory(inject(GridStateManagerService));
      return initializerFn();
    }),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([pendingRequestsInterceptor$])),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SubmitInterceptor,
      multi: true,
    },
  ],
})
export class AppModule {}
